import React from 'react';
import Icon from '../../../components/AppIcon';

const TabNavigation = ({ activeTab, onTabChange, tabs }) => {
  return (
    <div className="sticky top-16 z-900 bg-background border-b border-border">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="overflow-x-auto scrollbar-hide">
          <div className="flex gap-2 md:gap-4 lg:gap-6 min-w-max py-3 md:py-4">
            {tabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => onTabChange(tab?.id)}
                className={`flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 rounded-lg font-caption font-semibold text-sm md:text-base transition-smooth whitespace-nowrap flex-shrink-0 ${
                  activeTab === tab?.id
                    ? 'bg-primary text-primary-foreground shadow-warm'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
              >
                <Icon name={tab?.icon} size={20} />
                <span>{tab?.label}</span>
                {tab?.count > 0 && (
                  <span className={`px-2 py-0.5 rounded-full text-xs font-caption ${
                    activeTab === tab?.id
                      ? 'bg-primary-foreground/20 text-primary-foreground'
                      : 'bg-muted text-muted-foreground'
                  }`}>
                    {tab?.count}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabNavigation;